<div class="dashboard-luminarias">
  <app-dashboard-filtros titulo="Luminarias">
    <button
      irxBotonIcono
      filtros-acciones
      tooltip="Restaurar el orden original de los paneles"
      (click)="grilla.restaurarOrden()"
    >
      <mat-icon>restart_alt</mat-icon>
    </button>
  </app-dashboard-filtros>

  <!-- Tarjetas de indicador -->
  <div class="stat-cards-fila dashboard-indicadores">
    @if (cargandoStatCards) {
      <div class="stat-cards-loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando tarjetas de estadísticas...</p>
      </div>
    } @else {
      @for (card of statCards; track $index) {
        <app-stat-card
          [config]="card"
          [formatAsNumber]="true"
          numberFormat="1.0-2"
        ></app-stat-card>
      }
    }
  </div>

  <!-- Grilla de paneles ordenables -->
  <app-dashboard-grilla
    #grilla
    [(items)]="graficos"
    claveOrden="dashboard-luminarias-orden-graficos"
  >
    <ng-template let-grafico>
      <app-dashboard-panel [titulo]="grafico.titulo" [icono]="grafico.icono">
        @if (grafico.id === 'consumo') {
          <app-date-picker
            panel-acciones
            mode="monthrange"
            matTooltip="Período"
            [maxDate]="hoy"
            [(ngModel)]="rangoMesesConsumo"
            (ngModelChange)="onRangoMesesConsumoChange($event)"
          ></app-date-picker>
        }

        @if (!graficoListo(grafico.id)) {
          <div class="dpanel-vacio" [style.min-height]="grafico.altura">
            <mat-spinner diameter="36"></mat-spinner>
            <p>Cargando…</p>
          </div>
        } @else if (!tieneDatos(grafico)) {
          <div class="dpanel-vacio" [style.min-height]="grafico.altura">
            <mat-icon>{{ grafico.icono }}</mat-icon>
            <p>{{ grafico.sinDatos }}</p>
          </div>
        } @else {
          @switch (grafico.tipo) {
            @case ('heatmap') {
              <app-heatmap-cortes
                [datos]="obtenerDatosGrafico(grafico.id)"
                [nombreMap]="'heatmap-' + grafico.id"
                [altura]="grafico.altura"
                [titulo]="''"
              ></app-heatmap-cortes>
            }
            @case ('bar') {
              <app-graficos
                tipo="bar"
                [series]="obtenerDatosGrafico(grafico.id)"
                [categorias]="obtenerCategoriasGrafico(grafico.id)"
                [titulo]="''"
                [tituloEjeX]="
                  grafico.id === 'tiempoEncendido'
                    ? 'Rango de horas encendidas'
                    : ''
                "
                [altura]="grafico.altura"
                [ocultarLabelsEjes]="false"
                [mostrarLeyenda]="false"
              ></app-graficos>
            }
            @case ('column') {
              <app-graficos
                tipo="column"
                [series]="obtenerDatosGrafico(grafico.id)"
                [categorias]="obtenerCategoriasGrafico(grafico.id)"
                [titulo]="''"
                [tituloEjeX]="grafico.id === 'consumo' ? 'Mes/Año' : ''"
                [tituloEjeY]="grafico.id === 'consumo' ? 'Consumo total' : ''"
                [altura]="grafico.altura"
                [mostrarLeyenda]="false"
                [ocultarLabelsEjes]="false"
              ></app-graficos>
            }
            @case ('heatmapChart') {
              <app-graficos
                tipo="heatmap"
                [datosHeatmap]="datosCanalesHeatmap"
                [categorias]="categoriasCanalesFechas"
                [categoriasY]="categoriasCanalesFrecuencias"
                [titulo]="''"
                [tituloEjeY]="'Frecuencia (MHz)'"
                [altura]="grafico.altura"
                [mostrarLeyenda]="false"
                [mostrarEtiquetas]="false"
              ></app-graficos>
            }
            @case ('line') {
              <app-graficos
                tipo="line"
                [series]="obtenerDatosGrafico(grafico.id)"
                [categorias]="obtenerCategoriasGrafico(grafico.id)"
                [titulo]="''"
                [tituloEjeX]="grafico.id === 'cortes' ? 'Día de la semana' : ''"
                [tituloEjeY]="
                  grafico.id === 'cortes'
                    ? 'Cantidad de luminarias afectadas'
                    : ''
                "
                [altura]="grafico.altura"
                [mostrarPuntos]="true"
                [suavizado]="true"
                [permitirDecimales]="false"
                [ocultarLabelsEjes]="false"
                [mostrarLeyenda]="false"
              ></app-graficos>
            }
            @case ('eventos') {
              <!-- Auto-consulta sus propios datos -->
              <app-grafico-eventos-luminarias
                [idCliente]="idClientePropio"
                [titulo]="grafico.titulo"
                [mostrarTitulo]="false"
                [altura]="grafico.altura"
                [card]="false"
              ></app-grafico-eventos-luminarias>
            }
            @case ('tabla') {
              @if (grafico.id === 'cortesDetallados') {
                @if (cortesDetallados.length > 0) {
                  <div class="tabla-scroll-wrapper">
                    <app-tabla
                      [columnas]="columnasCortesDetallados"
                      [datos]="cortesDetallados"
                      [paginatorAbajo]="false"
                      [buttonColumns]="false"
                    ></app-tabla>
                  </div>
                } @else {
                  <div class="dpanel-vacio">
                    <mat-icon>{{ grafico.icono }}</mat-icon>
                    <p>
                      No se registraron cortes de energía en las últimas 24
                      horas
                    </p>
                  </div>
                }
              } @else if (grafico.id === 'encendidoDetallado') {
                @if (encendidoDetallado.length > 0) {
                  <div class="tabla-scroll-wrapper">
                    <app-tabla
                      [columnas]="columnasEncendidoDetallado"
                      [datos]="encendidoDetallado"
                      [paginatorAbajo]="false"
                      [buttonColumns]="false"
                    ></app-tabla>
                  </div>
                } @else {
                  <div class="dpanel-vacio">
                    <mat-icon>{{ grafico.icono }}</mat-icon>
                    <p>No hay datos de encendido diario disponibles</p>
                  </div>
                }
              }
            }
            @default {
              <!-- pie / donut -->
              <app-graficos
                [tipo]="grafico.tipo"
                [datos]="obtenerDatosGrafico(grafico.id)"
                [titulo]="''"
                [altura]="grafico.altura"
                [mostrarLeyenda]="true"
                [posicionLeyenda]="'right'"
                [mostrarEtiquetas]="false"
              ></app-graficos>
            }
          }
        }
      </app-dashboard-panel>
    </ng-template>
  </app-dashboard-grilla>
</div>
